import styled from 'styled-components';

export const PortalInfoStyled = styled.p`
  border: 1px solid #d1d1d1;
  border-radius: 8px;
  margin: 30px 0px 24px;
  padding: 10px;
  font-size: 14px;
`;
